export const COLUMN_WIDTHS = {
  EVENT_NAME: '20%',
  DESCRIPTION: '30%',
  PARTNER: '10%',
  EMAIL: '10%',
  IN_APP: '10%',
  BANNER: '15%',
} as const

export enum ToggleType {
  Email = 'email',
  InApp = 'inApp',
}
